<template>
  <form v-show="false" id="jwtForm" method="post" :action="this.ssoUrl">
    <input id="jwtInput" type="text" name="jwt" :value="this.token" />
  </form>
</template>

<script>
import { mapState } from "vuex";
import AddonLoadPageEvent from '@/mixin/AddonLoadPageEvent'

export default {
  name: 'ZendeskLogin',
  components: {
  },
  mixins: [
    AddonLoadPageEvent,
  ],
  provide: {
  },
  inject: [
  ],
  computed: {
    ...mapState("zendesk", {
      ssoUrl: (state) => state.data.ssoUrl,
      token: (state) => state.data.token,
    }),
  },
  mounted() {
    this.$store.commit('zendesk/resetData');
  },
  methods: {
    loadPage() {
      this.$store.dispatch('zendesk/sso').then(() => {
        document.forms['jwtForm'].submit();
     }).catch(reason => {
        if (reason.response.status === 401) {
          this.$root.showFlashMessage();
          setTimeout(() => this.$router.push({ name: "Login", }), 5000);
        } else {
          this.$root.failApi(reason);
        }
      });
    },
  },
}
</script>
